// The picture of an analogue clock. Plain React SVG, like
// practice-instrument.tsx. The time is shown only by the two hands.

import {
  CLOCK_NUMBER_SIZE,
  clockFacePicture,
  describeClock,
  type ClockSpec,
} from './practice-clock-data';

const INK = '#2d4a3e';

export function ClockPictureView({ clock }: { clock: ClockSpec }) {
  const picture = clockFacePicture(clock);
  const { centre } = picture;

  return (
    <figure className="m-0 max-w-md">
      <svg
        role="img"
        aria-label={describeClock()}
        viewBox={`0 0 ${String(picture.size)} ${String(picture.size)}`}
        className="mx-auto block h-auto w-full"
        style={{ maxWidth: `${String(Math.round(picture.size * 1.3))}px` }}
      >
        <circle
          data-face="true"
          cx={centre}
          cy={centre}
          r={picture.radius}
          fill="#ffffff"
          stroke={INK}
          strokeWidth="3"
        />
        {picture.marks.map((mark, index) => (
          <line
            key={index}
            data-mark={mark.long ? 'long' : 'short'}
            x1={mark.x1}
            y1={mark.y1}
            x2={mark.x2}
            y2={mark.y2}
            stroke={INK}
            strokeWidth={mark.long ? '2.5' : '1.2'}
          />
        ))}
        {picture.hands.map((hand) => (
          <line
            key={hand.name}
            data-hand={hand.name}
            data-angle={hand.angle}
            x1={centre}
            y1={centre}
            x2={hand.x}
            y2={hand.y}
            stroke={INK}
            strokeWidth={hand.width}
            strokeLinecap="round"
          />
        ))}
        <circle cx={centre} cy={centre} r="5" fill={INK} />
        {/* The numbers go on top, each with a white edge, so one stays
            readable when a hand passes over it. */}
        {picture.numbers.map((number) => (
          <text
            key={number.value}
            data-number="true"
            x={number.x}
            y={number.y}
            dy="0.35em"
            textAnchor="middle"
            fill={INK}
            stroke="#ffffff"
            strokeWidth="4"
            paintOrder="stroke"
            fontSize={CLOCK_NUMBER_SIZE}
            fontWeight="600"
          >
            {number.value}
          </text>
        ))}
      </svg>
    </figure>
  );
}
